let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hYWtF")).then(() => parcelRequire('5JtnX'));